module.exports = __webpack_public_path__ + "img/cube.e3bfecc2.svg";